<button
  mat-icon-button
  mat-dialog-close
  class="celo-dialog-close celo-dialog-close--floating"
  aria-label="Close"
>
  <i class="material-icons">close</i>
</button>
@if (data && data.invitationObj && data.invitationObj.metadata) {
  <div class="celo-break-word">
    <!-- UserSpecificWorkspaceJoin -->
    @if (
      !joinWorkspaceErrorDescriptor &&
      data.invitationObj.type === "UserSpecificWorkspaceJoin"
    ) {
      <div>
        <div class="title-line">
          <div class="icon">
            <mat-icon [svgIcon]="'home_outline'"></mat-icon>
          </div>
          <span class="title"
            >&nbsp;{{ data.invitationObj.metadata.name }}</span
          >
        </div>
        <div class="subtitle">You are now a member of this workspace.</div>
        <div class="button">
          <button
            mat-button
            class="celo-primary-button uppercase"
            (click)="viewWorkspace(data.invitationObj.metadata.id)"
            [disabled]="loading"
          >
            View Workspace
          </button>
        </div>
      </div>
    }
    <!-- WorkspaceJoin -->
    @if (
      !joinWorkspaceErrorDescriptor &&
      data.invitationObj.type === "WorkspaceJoin"
    ) {
      <div>
        <div class="title-line">
          <div class="icon">
            <mat-icon [svgIcon]="'home_outline'"></mat-icon>
          </div>
          @if (data.invitationObj.isActive) {
            <span class="title"
              >&nbsp;{{ data.invitationObj.metadata.name }}</span
            >
          }
        </div>
        @if (data.invitationObj.isActive) {
          <div>
            @if (!data.invitationObj.isActioned) {
              <div>
                <div class="subtitle">
                  Join your colleagues in
                  {{ data.invitationObj.metadata.name }} Workspace.
                </div>
                <div class="button">
                  <button
                    mat-button
                    class="celo-primary-button uppercase"
                    (click)="action(data.invitationObj.id)"
                    [disabled]="loading"
                  >
                    Join
                  </button>
                </div>
              </div>
            }
            @if (data.invitationObj.isActioned) {
              <div>
                <div class="subtitle">
                  You are now a member of this workspace.
                </div>
                <div class="button">
                  <button
                    mat-button
                    class="celo-primary-button uppercase"
                    (click)="viewWorkspace(data.invitationObj.metadata.id)"
                  >
                    View Workspace
                  </button>
                </div>
              </div>
            }
          </div>
        }
        @if (!data.invitationObj.isActive) {
          <div>
            <div class="subtitle">
              The invite link for this workspace has been reset. Please ensure
              you have the latest invite link to join the workspace.
            </div>
          </div>
        }
      </div>
    }
    <!-- Error actioning UserSpecificWorkspaceJoin or WorkspaceJoin -->
    @if (joinWorkspaceErrorDescriptor) {
      <div>
        <div class="title-line">
          <div class="icon">
            <mat-icon [svgIcon]="'home_outline'"></mat-icon>
          </div>
          <span class="title"
            >&nbsp;{{ data.invitationObj.metadata.name }}</span
          >
        </div>
        <div
          class="subtitle error"
          [innerText]="joinWorkspaceErrorDescriptor.message"
        ></div>
        <div class="button">
          <button
            mat-button
            class="celo-primary-button uppercase"
            (click)="close()"
          >
            Done
          </button>
        </div>
      </div>
    }
    <!-- Group/Case -->
    @if (
      data.invitationObj.type === "Group" || data.invitationObj.type === "Case"
    ) {
      <div>
        <div class="title-line">
          <div class="icon">
            @if (data.invitationObj.type === "Group") {
              <mat-icon [svgIcon]="'avatar-group'"></mat-icon>
            }
            @if (data.invitationObj.type === "Case") {
              <mat-icon [svgIcon]="'avatar-patient'"></mat-icon>
            }
          </div>
          @if (data.invitationObj.isActive) {
            <span class="title"
              >&nbsp;{{ data.invitationObj.metadata.name }}</span
            >
          }
        </div>
        @if (data.invitationObj.isActive) {
          <div>
            @if (!data.invitationObj.isActioned) {
              <div>
                <div class="subtitle">
                  Join your colleagues in {{ data.invitationObj.metadata.name }}
                  <span class="lowercase">{{ data.invitationObj.type }}</span
                  >.
                </div>
                <div class="button">
                  <button
                    mat-button
                    class="celo-primary-button uppercase"
                    (click)="action(data.invitationObj.id)"
                    [disabled]="loading"
                  >
                    Join {{ data.invitationObj.type }}
                  </button>
                </div>
              </div>
            }
            @if (data.invitationObj.isActioned) {
              <div>
                <div class="subtitle">
                  You are now a member of this
                  <span class="lowercase">{{ data.invitationObj.type }}</span
                  >.
                </div>
                <div class="button">
                  <button
                    mat-button
                    class="celo-primary-button uppercase"
                    (click)="viewConversation(data.invitationObj.metadata.id)"
                  >
                    View {{ data.invitationObj.type }}
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    <!-- User -->
    @if (data.invitationObj.type === "User") {
      <div>
        <app-profile-invitation
          [userId]="data.invitationObj.metadata.id"
          [code]="data.invitationObj.id"
          [invitation]="data.invitationObj"
          (action)="action(data.invitationObj.id)"
        ></app-profile-invitation>
      </div>
    }
  </div>
}
